import type { BriefingGenerationStatus } from "api/briefingApi.slice";
import { useTranslate } from "common/utilities/useTranslate";
import * as Styled from "domains/briefing/components/CompletedGenerationMessage/CompletedGenerationMessage.styled";

type CompletedGenerationMessageProps = { status: BriefingGenerationStatus };

export const CompletedGenerationMessage = ({ status }: CompletedGenerationMessageProps) => {
  const translate = useTranslate();

  if (status === "Processing") return null;

  if (status === "Error") return <Styled.Text>{translate("app.briefing.error")}</Styled.Text>;

  return <Styled.Text>{translate("app.briefing.download_ready")}</Styled.Text>;
};
